import { render, staticRenderFns } from "./AulaCadastro.vue?vue&type=template&id=1b2f5316&"
import script from "./AulaCadastro.vue?vue&type=script&lang=js&"
export * from "./AulaCadastro.vue?vue&type=script&lang=js&"
import style0 from "./AulaCadastro.vue?vue&type=style&index=0&id=1b2f5316&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports